import { Component, OnInit, Inject } from '@angular/core';
import { filter } from 'rxjs/operators';

import { DATEPICKER_INPUT_DIRECTIVE } from '../datepicker-input/datepicker-input.token';
import { DatepickerInputDirective } from '../datepicker-input/datepicker-input.directive';

/**
 **************************    CURENTLY NOT USED!!!    ********************************
 *
 * want to try and move any logic that updates the datepicker-input to this component and
 * just have the calendar component emit events when the user clicks a new value
 */
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'cf-datepicker-calendar',
  templateUrl: './datepicker-calendar.component.html',
  styleUrls: ['./datepicker-calendar.component.scss']
})
export class DatepickerCalendarComponent implements OnInit {
  date: string;

  constructor(
    @Inject(DATEPICKER_INPUT_DIRECTIVE) private datepicker: DatepickerInputDirective
  ) { }

  ngOnInit() {
    // subscribe to input value changes
    this.datepicker.inputValueChange.pipe(
      filter(this.isValidDate)
    ).subscribe(value => {
      this.date = value;
    });
  }

  setInputValue(date) {
    if (date !== this.datepicker.element.nativeElement.value) {
      this.datepicker.setValue(date);
    }
  }

  private isValidDate(date) {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker/datepicker-calendar/datepicker-calendar.component.ts